export default "__VITE_ASSET__BTiA5OEI__"